/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ loadText: NonNullable<unknown> }} Progress_Report_Exercise_E1rmInputs */

const en_us2_progress_report_exercise_e1rm = /** @type {(inputs: Progress_Report_Exercise_E1rmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.loadText} estimated 1RM`)
};

const pt_br2_progress_report_exercise_e1rm = /** @type {(inputs: Progress_Report_Exercise_E1rmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.loadText} de 1RM estimado`)
};

const es_419_progress_report_exercise_e1rm = /** @type {(inputs: Progress_Report_Exercise_E1rmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.loadText} de 1RM estimado`)
};

const pt_pt2_progress_report_exercise_e1rm = /** @type {(inputs: Progress_Report_Exercise_E1rmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.loadText} de 1RM estimado`)
};

const fr_fr2_progress_report_exercise_e1rm = /** @type {(inputs: Progress_Report_Exercise_E1rmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.loadText} de 1RM estimé`)
};

const de_de2_progress_report_exercise_e1rm = /** @type {(inputs: Progress_Report_Exercise_E1rmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.loadText} geschätztes 1RM`)
};

const it_it2_progress_report_exercise_e1rm = /** @type {(inputs: Progress_Report_Exercise_E1rmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.loadText} di 1RM stimato`)
};

/**
* | output |
* | --- |
* | "{loadText} estimated 1RM" |
*
* @param {Progress_Report_Exercise_E1rmInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_report_exercise_e1rm = /** @type {((inputs: Progress_Report_Exercise_E1rmInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Report_Exercise_E1rmInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_report_exercise_e1rm(inputs)
	if (locale === "es-419") return es_419_progress_report_exercise_e1rm(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_report_exercise_e1rm(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_report_exercise_e1rm(inputs)
	if (locale === "de-DE") return de_de2_progress_report_exercise_e1rm(inputs)
	if (locale === "it-IT") return it_it2_progress_report_exercise_e1rm(inputs)
	return en_us2_progress_report_exercise_e1rm(inputs)
});
export { progress_report_exercise_e1rm as "progress-report.exercise_e1rm" }